import { useMemo } from 'react'

import {
  BankAccountSelectorF0Document,
  CurrenciesFilterDataDocument,
} from 'generated/resources/graphql'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import { useQuery } from 'modules/core/hooks/useQuery'

import { createAccountFilter, createCurrencyFilter, dateFilter, statusFilter } from './filters'

export const usePaymentsFilters = () => {
  const { data: currenciesData } = useQuery(CurrenciesFilterDataDocument)

  const bankAccountsSource = useGraphqlDataSource(
    {
      document: BankAccountSelectorF0Document,
      paginationType: 'infinite-scroll',
      perPage: 20,
      search: { enabled: true },
      mapVariables: ({ search }) => ({
        search: search || undefined,
      }),
      mapData: (data) =>
        data.banking?.bankAccountsConnection?.edges?.map((edge) => edge.node) ?? [],
      mapPagination: (data) => ({
        total: data.banking?.bankAccountsConnection?.totalCount ?? 0,
        cursor: data.banking?.bankAccountsConnection?.pageInfo?.endCursor ?? undefined,
        hasNextPage: data.banking?.bankAccountsConnection?.pageInfo?.hasNextPage ?? false,
      }),
    },
    []
  )

  const currencyOptions = useMemo(() => {
    const currencies = currenciesData?.apiCore?.currencies || []
    return currencies.map((currency) => ({
      label: `${currency.isoCode} - ${currency.name}`,
      value: currency.isoCode,
    }))
  }, [currenciesData])

  // Note: dueDate is now a navigationFilter (visible DateNavigator) instead of a regular filter
  return useMemo(
    () => ({
      status: statusFilter(),
      date: dateFilter(),
      currency: createCurrencyFilter(currencyOptions),
      account: createAccountFilter(bankAccountsSource),
    }),
    [bankAccountsSource, currencyOptions]
  )
}
